import Vue from 'vue'
import Router from 'vue-router'
import { getCookie } from '../helpers'
import App from '../App'
import LoginPage from '../components/pages/LoginPage'
import LogoutPage from '../components/pages/LogoutPage'
import SignupPage from '../components/pages/SignupPage'
import PlacesPage from '../components/pages/PlacesPage'
import PlacePage from '../components/pages/PlacePage'
import AccessDeniedPage from '../components/pages/AccessDeniedPage'
import AddPlacePage from '../components/pages/AddPlacePage'
import AddPlaceTranslationPage from '../components/pages/AddPlaceTranslationPage'
import EditPlaceTranslationPage from '../components/pages/EditPlaceTranslationPage'
import EditPlacePage from '../components/pages/EditPlacePage'
import AddQuizPage from '../components/pages/AddQuizPage'
import EditQuizPage from '../components/pages/EditQuizPage'
import UsersPage from '../components/pages/UsersPage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/logout',
      name: 'logout',
      component: LogoutPage
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignupPage
    },
    {
      path: '/403',
      name: 'AccessDenied',
      component: AccessDeniedPage
    },
    {
      path: '/:lang',
      component: App,
      children: [
        {
          path: '',
          alias: '/:lang/places',
          name: 'places',
          component: PlacesPage
        },
        {
          path: '/:lang/places/add',
          name: 'addplace',
          component: AddPlacePage
        },
        {
          path: '/:lang/places/:id/edit',
          name: 'editplace',
          component: EditPlacePage
        },
        {
          path: '/:lang/places/:id',
          name: 'viewplace',
          component: PlacePage
        },
        {
          path: '/:lang/places/:placeId/translate',
          name: 'addplacetranslation',
          component: AddPlaceTranslationPage
        },
        {
          path: '/:lang/places/:id/translate/:translationId/edit',
          name: 'editplacetranslation',
          component: EditPlaceTranslationPage
        },
        {
          path: '/:lang/places/:id/quiz',
          name: 'addquiz',
          component: AddQuizPage
        },
        {
          path: '/:lang/places/:id/quiz/:quizId',
          name: 'addquiztranslation',
          component: AddQuizPage
        },
        {
          path: '/:lang/places/:id/quiz/:quizId/edit',
          name: 'editquiz',
          component: EditQuizPage
        },
        {
          path: '/:lang/users',
          name: 'userspage',
          component: UsersPage
        }
      ],
      beforeEnter: (to, from, next) => {
        if (getCookie('redecienciaToken')) {
          // console.log('1')
          document.redecienciaToken = getCookie('redecienciaToken')
          next()
        } else {
          // console.log('2')
          next({ path: '/login' })
        }
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js